// Dated statutory figures for the calculators (Great Britain).
// Every figure carries its rule ID (docs/calculator-rule-register.md), its
// authority and the date it applies from. Add new rows each April; never
// overwrite old ones, because a calculation must use the figure in force on
// its legally applicable date.

// ERA 1996 s227(1) maximum week's pay. Selected by the redundancy relevant
// date as extended by s145(5) (s227(3)).
export const WEEK_PAY_CAPS = [
  { id: "RED-CAP", from: "2026-04-06", amount: 751, authority: "Employment Rights (Increase of Limits) Order 2026, SI 2026/310" },
  { id: "RED-CAP", from: "2025-04-06", amount: 719, authority: "Employment Rights (Increase of Limits) Order 2025, SI 2025/348" },
];

// National Minimum Wage Regulations 2015 reg 4 (as amended), UK-wide.
export const MINIMUM_WAGE = [
  {
    id: "PRO-NMW",
    from: "2026-04-01",
    authority: "National Minimum Wage (Amendment) Regulations 2026, SI 2026/357",
    bands: [
      { id: "21plus", label: "21 and over (National Living Wage)", rate: 12.71 },
      { id: "18to20", label: "18 to 20", rate: 10.85 },
      { id: "under18", label: "Under 18", rate: 8.0 },
      { id: "apprentice", label: "Apprentice (under 19, or in first year)", rate: 8.0 },
    ],
  },
];

// WTR 1998 reg 15B(3) and reg 16A(2): 12.07% for leave years from 1 April 2024.
export const IRREGULAR_ACCRUAL = { id: "HOL-1207", from: "2024-04-01", rate: 0.1207, authority: "Working Time Regulations 1998, regs 15B and 16A" };

// ITEPA 2003 s403(1): threshold for non-earnings termination payments.
export const TERMINATION_TAX_FREE = { id: "RED-TAX", amount: 30000, authority: "Income Tax (Earnings and Pensions) Act 2003, s403" };

// Social Security Contributions and Benefits Act 1992 s9A and s10, ITEPA 2003
// s403: employer Class 1A on termination awards above the £30,000 threshold.
export const CLASS_1A_RATES = [
  { id: "PKG-1A", from: "2025-04-06", rate: 0.15, authority: "GOV.UK: Rates and thresholds for employers 2026 to 2027" },
];

// Latest row in force on a date (YYYY-MM-DD strings compare correctly).
export const inForceOn = (rows, iso) =>
  [...rows].sort((a, b) => (a.from < b.from ? 1 : -1)).find((r) => iso >= r.from) || null;

export const currentMinimumWage = () => MINIMUM_WAGE[0];
